<template>
  <modal
    title="Unassign?"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="delete-illustration-wrapper text-center">
      <img
        src="@/assets/images/delete-illustration.png"
        alt="Delete illustration"
        class="img-fluid"
      />
      <small>
        You are about to unassign this consolidation from a fleet. Would you
        like to continue?</small
      >
    </div>
    <div class="actions">
      <button class="cancel-btn cursor-pointer" @click="$emit('close-modal')">
        Cancel
      </button>

      <base-button
        text="Unassign"
        @click="$emit('unassign')"
        :loading="loading"
      />
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedModule: null,
      moduleOptions: [],
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    deleteItem() {
      this.$emit("delete-item");
    },
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 0 1rem;
}
.actions button {
  padding: 0.25rem 0.75rem;
  border-radius: 3px;
}
.cancel-btn {
  color: #f57a4d;
}
.edit-btn {
  background: #f57a4d;
  color: #ffffff;
}
.delete-illustration-wrapper img {
  margin: 1rem auto;
  width: 4rem;
  height: auto;
}
</style>
